import React from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { access, defaultRoute } from '../../../common/Tool';
import { useAuth, useMetaContext, useTranslateContext, useUserConfigContext, useUserContext } from 'fennec-ui';
import { useDispatch, useSelector } from 'react-redux';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import Events from './Events';
import { ConfigProvider, theme } from 'antd';
import { BreadcrumbsProvider, MenuLevelTwoContext, MenuLevelTwoElementContext } from '../../../common/Context';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function Kurator(props) {
    let { id } = useParams();
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const auth = useAuth();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    // const langSwitch = useLangSwitchContext();

    const siteAccess = useSelector(state => state.siteAccess.value);

    const role_by_id = useSelector(state => state.home.role_by_id);
    const status = useSelector(state => state.home.status, () => { }); // Статусы
    const notify = useSelector(state => state.home.notify, () => { }); // Уведомления

    const menu = (status, notify) => {
        const x = [
            {
                uuid: "events",
                default: true,
                name: "Мероприятия",
                component: (props) => (<Events {...props} />),
                role: [
                    { "ID": 33, "nazvanie": "Куратор" },
                ],
            },
        ]
        return x
    };

    return (
        <div>
           <MenuLevelTwoContext.Provider value={menu(status, notify)}>
                {(!siteAccess || siteAccess == "allow") && <Routes>
                    {defaultRoute(menu(status, notify), role_by_id)}
                    {menu(status, notify).map((e, idx) => {
                        if (e.component && access(e, role_by_id)) {
                            return <Route key={e.uuid} path={(e.uuid !== "*")?e.uuid + "/*":"*"} element={
                                <BreadcrumbsProvider value={{
                                    // parent: props?.level,
                                    uuid: e?.uuid,
                                    name: e?.name,
                                    color: e?.color,
                                    role: e?.role,
                                    hidden: e.hidden
                                }}>
                                    {e.component({})}
                                </BreadcrumbsProvider>}
                            />
                        }
                    })}
                </Routes>}
            </MenuLevelTwoContext.Provider>
        </div>
    );
}
